const openModal = (id: string, context?: unknown) => {
  // Ensure the DOM is synchronized before accessing the element
  requestAnimationFrame(() => {
    const modal = document.getElementById(id)
    const bodyScrollTarget = modal && modal.querySelector('.modal-body')

    if (!modal) {
      return
    }

    let modalContext = ''
    try {
      modalContext = JSON.stringify(context)
    } catch (err) {
      console.warn('Could not stringify context', context)
    }

    // Modal was hide for performance reasons
    modal.style.display = 'block'
    // Need to enable animation
    setTimeout(() => {
      document.dispatchEvent(new Event(`open-${id}`))
      modal.classList.add('open')
      modal.setAttribute('aria-hidden', 'false')
      modal.setAttribute('aria-expanded', 'true')
      modal.setAttribute('tabindex', '0')
      if (modalContext) {
        modal.setAttribute('data-context', modalContext)
      } else {
        modal.removeAttribute('data-context')
      }
      modal.focus()
      if (bodyScrollTarget) window.bodyScrollLock?.disableBodyScroll(bodyScrollTarget)
    })
  })
}

const closeModal = (id: string) => {
  const modal = document.getElementById(id)
  const allModalOpened = document.querySelectorAll('.modal.open')

  if (!modal) {
    return
  }
  modal.classList.remove('open')
  modal.setAttribute('aria-hidden', 'true')
  modal.setAttribute('aria-expanded', 'false')
  modal.setAttribute('tabindex', '-1')
  if (allModalOpened.length == 1) {
    window.bodyScrollLock?.clearAllBodyScrollLocks()
  }
  setTimeout(() => {
    modal.style.display = 'none' 
  }, 1000);
}

export { openModal, closeModal }
